module.exports = "/_next/static/democontent.png";